
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";
import base64 from "base-64"


export default class DetailOtherFile extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let {detailData={}} = this.props;
        let {storageFile={}} = detailData;
        let {path=""} = storageFile;
        let {name=""} = storageFile;
        let urlHost =window.location.origin;
        if(urlHost.indexOf('127.0.0.1')>-1) {
            urlHost = 'http://192.168.120.50:9241'
        }
        let preivewUrl =encodeURIComponent(base64Encode(`${urlHost}${path}?fullfilename=${name}`));
        let officeViewUrl = urlHost + '/kkfileview/onlinePreview' + "?url=" +preivewUrl;
        return (
            <div style={{width:"100%",height:"100%"}}>
                <iframe style={{width:"100%",height:"100%"}}
                    src={officeViewUrl}>
                </iframe>
            </div>
        )
    }

}
function base64Encode(str){
    // 对字符串进行编码
    var encode =encodeURI(str);
    // 对编码的字符串转化base64
    var base64 = btoa(encode);
    return base64;
}